import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=ba8d146e&scoped=true"
import script from "./Styles.vue?vue&type=script&lang=ts"
export * from "./Styles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8d146e",
  null
  
)

export default component.exports